import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useChartPeriod } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  CurrencyValue,
  Flex,
  LineChart,
  formatNumber
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';

export default function HistoricTabs({ ilk }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/rwa/${ilk}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          key="debt"
          data={data['results']}
          datasets={[
            {
              xField: 'date',
              yField: 'debt'
            }
          ]}
          valueFormatter={(value: number) => (
            <CurrencyValue
              value={value}
              options={{
                currency: tokensMapping('DAI'),
                iconSize: '3'
              }}
            />
          )}
          yScaleValueFormatter={(value: number) => formatNumber(value)}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
